// Types pour le module Banking
// Basés sur les types Supabase (source de vérité)

import type { Row, Insert, Update, Enums } from '@/shared/types/database'
import type { ResidenceChartAccount } from '@/features/accounting/types'

// ===== ENUMS (depuis Supabase) =====
export type BankAccountType = Enums<'bank_account_type'>
export type BankReconciliationStatus = Enums<'bank_reconciliation_status'>
export type BankImportSource = Enums<'bank_import_source'>
export type BankImportFormat = Enums<'bank_import_format'>

// ===== COMPTES BANCAIRES =====
export type BankAccount = Row<'bank_accounts'> & {
  residence_chart_account?: ResidenceChartAccount
}

export type BankAccountInsert = Insert<'bank_accounts'>
export type BankAccountUpdate = Update<'bank_accounts'>

export interface BankAccountCreate {
  residence_id: string
  label: string
  account_type: BankAccountType
  iban: string
  bic?: string
  bank_name: string
  account_holder: string
  is_primary?: boolean
}

// ===== MOUVEMENTS BANCAIRES (futures fonctionnalités) =====
export type BankStatement = Row<'bank_statements'> & {
  bank_account?: BankAccount
}

export type BankStatementInsert = Insert<'bank_statements'>
export type BankStatementUpdate = Update<'bank_statements'>

// ===== IMPORTS (futures fonctionnalités) =====
export type BankStatementImport = Row<'bank_statement_imports'> & {
  bank_account?: BankAccount
}

export type BankStatementImportInsert = Insert<'bank_statement_imports'>

// ===== LABELS ET HELPERS =====
export const BANK_ACCOUNT_TYPE_LABELS: Record<BankAccountType, string> = {
  current: 'Compte courant',
  savings: 'Compte épargne',
  alur_reserve: 'Fonds travaux ALUR',
}

export const BANK_ACCOUNT_TYPE_DESCRIPTIONS: Record<BankAccountType, string> = {
  current: 'Compte bancaire principal pour les opérations courantes',
  savings: 'Compte d\'épargne pour la trésorerie',
  alur_reserve: 'Fonds de travaux obligatoire (loi ALUR) pour copropriétés >15 lots',
}

export const BANK_ACCOUNT_TYPE_COLORS: Record<BankAccountType, string> = {
  current: 'blue',
  savings: 'green',
  alur_reserve: 'purple',
}

export const RECONCILIATION_STATUS_LABELS: Record<BankReconciliationStatus, string> = {
  pending: 'En attente',
  partial: 'Partiel',
  reconciled: 'Rapproché',
  ignored: 'Ignoré',
}

// ===== FILTRES =====
export interface BankAccountFilters {
  residence_id: string
  is_active?: boolean
  account_type?: BankAccountType
}

export interface BankStatementFilters {
  bank_account_id: string
  date_from?: string
  date_to?: string
  reconciliation_status?: BankReconciliationStatus
  search?: string
}
